<div class="container-fluid p-0 m-0">
  @if (isAuthenticated) {
  <app-header [authUser]="authUser" />
  }
  <router-outlet></router-outlet>
  @if (isAuthenticated) {
  <app-footer />
  }
</div>